// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapDialog .selectDot[data-v-8bb38868] {\n  margin-bottom: 25px;\n  color: black;\n}\n.wrapDialog .undistributed[data-v-8bb38868] {\n  margin-top: 10px;\n  font-size: 12px;\n  color: #a4a7ab;\n}", ""]);
// Exports
module.exports = exports;
